import { formatCurrency } from '@/app/utils/formatCurrency';

// elemis returns every schedule amount (instalment rows, `meta.total_repayable`,
// etc.) as an integer minor unit (contract §5/§6), but the shared
// `formatCurrency` (app/utils/formatCurrency.ts, the same Intl-based formatter
// used across quote/service-plans) takes major units. This is the single
// place that performs the minor -> major conversion for the payment-schedule
// step (#475-A/#475-B) — do not hand-roll `/100` at each call site.
const MINOR_UNITS_PER_MAJOR = 100;

/**
 * Formats an integer-minor-unit amount as a localised currency string.
 * Guards against a missing/non-numeric value so the UI never renders
 * "£NaN" — returns an em dash instead.
 */
export const formatMinorAmount = (minorAmount: number | undefined, currency: string): string => {
    if (typeof minorAmount !== 'number' || Number.isNaN(minorAmount)) {
        return '—';
    }
    return formatCurrency(minorAmount / MINOR_UNITS_PER_MAJOR, currency);
};
